import { IntakeRequestLineItem } from './IntakeRequestLineItemStep.schema';

export enum IntakeRequestStepLineItemGridField {
  POSITION = 'position',
  TITLE = 'title',
  DESCRIPTION = 'description',
  COMMODITY_GROUP_ID = 'commodityGroupId',
  UNIT_ID = 'unitId',
  QUANTITY = 'quantity',
  EXPCTED_PRICE_PER_UNIT = 'expectedPricePerUnit',
  EXPCTED_TOTAL_PRICE_PER_UNIT = 'expectedTotalPricePerUnit',
  EARLY_DELIVERY_AT = 'earlyDeliveryAt',
  LATE_DELIVERY_AT = 'lateDeliveryAt',
  DELIVERY_TIME = 'deliveryTime',
  DELETE_ACTION = 'deleteAction',
}

export enum IntakeRequestStepLineItemGridColumnGroup {
  PURCHASE_REQUISITION_LINE_ITEM = 'purchaseRequisitionLineItem',
  DELIVERY_DATE = 'deliveryDate',
  CLASSIFICATION = 'classification',
  ACTIONS = 'actions',
}

export type IntakeRequestStepLineItemGridRow = IntakeRequestLineItem;
